/* eslint-disable */ 
/* tslint:disable */ 
 
export interface AsitePlaceholderDto {
  /** @format uuid */
  placeholderId?: string;

  /** @format int32 */
  asiteDocumentsSyncLogId?: number | null;

  /** @format int32 */
  documentId?: number;

  /** @format int32 */
  revisionId?: number;
  workspaceName?: string | null;

  /** @format int32 */
  folderId?: number;
  documentTitle?: string | null;
  fileType?: string | null;
  docTypeAttribute?: string | null;
  status?: string | null;

  /** @format int32 */
  statusId?: number;
  link?: string | null;
  processing?: boolean;

  /** @format date-time */
  documentDate?: Date;
  documentRef?: string | null;

  /** @format date-time */
  b_Datum?: Date;

  /** @format double */
  fileSize?: number | null;
  fileGuid?: string | null;
  forceSync?: boolean;
  wbsValue?: string | null;
  attachment?: string | null;
  filePath?: string | null;
  purposeOfIssue?: string | null;

  /** @format date-time */
  publishingDate?: Date;

  /** @format date-time */
  modificationDate?: Date;

  /** @format int32 */
  version?: number | null;
  revisionNumber?: string | null;
  publisherName?: string | null;
  restricted?: boolean;
  attributes?: string | null;
  fileName?: string | null;
  fileNameDisplay?: string | null;

  /** @format int32 */
  purposeOfIssueId?: number | null;
  isLink?: boolean;
}

export interface CustomAttributeMappingDto {
  /** @format uuid */
  id?: string;

  /** @format int32 */
  workspaceId?: number | null;
  applicationCode?: string | null;
  externalCode?: string | null;
}

export interface DeelprojectDto {
  /** @format uuid */
  id?: string;
  name?: string | null;
  description?: string | null;
}

export interface DocumentLinkHistoryDto {
  /** @format uuid */
  id?: string;
  docRef?: string | null;

  /** @format int32 */
  sourceDocumentId?: number;

  /** @format int32 */
  sourceDocumentVersionId?: number;

  /** @format int32 */
  sourceFolderId?: number;

  /** @format int32 */
  targetFolderId?: number;

  /** @format int32 */
  sourceWorkspaceId?: number;

  /** @format int32 */
  targetWorkspaceId?: number;

  /** @format int32 */
  documentLinkId?: number;

  /** @format int32 */
  documentLinkVersionId?: number;

  /** @format int32 */
  linkType?: number;
}

export interface DocumentLinkHistoryFilterDto {
  /** @format int32 */
  targetFolderId?: number | null;
  documentVersionIds?: number[] | null;
}

export interface DocumentLinkSettingDto {
  /** @format uuid */
  id?: string | null;
  sourceDirectory?: string | null;
  documentType?: string | null;

  /** @format int32 */
  status?: number | null;
  disciplineCode?: string | null;
  organisation?: string | null;
  phase?: string | null;
  object?: string | null;
  deelproject?: string | null;
  purposeOfIssue?: string | null;
  isSharedPlaceholder?: boolean | null;
  linkDirectory?: string | null;

  /** @format int32 */
  targetFolderId?: number;
  targetProjectName?: string | null;

  /** @format int32 */
  targetProjectId?: number | null;

  /** @format int32 */
  sourceFolderId?: number;
  sourceProjectName?: string | null;

  /** @format int32 */
  sourceProjectId?: number | null;

  /** @format int32 */
  linkType?: "1" | "2" | null;

  /** @format int32 */
  forceSyncStatus?: "0" | "1" | "2" | null;

  /** @format date-time */
  lastSyncDate?: Date;
}

export interface PlaceholderDto {
  relaticsDocumentId?: string | null;
  organisation?: string | null;
  documentTitle?: string | null;
  deelproject?: string | null;
  phase?: string | null;
  object?: string | null;
  documentType?: string | null;
  disciplineCode?: string | null;
  relaticsSystem?: string | null;
  alternateReference?: string | null;
  workPackage?: string | null;
  linkSharedFolder?: boolean | null;
  purposeOfIssue?: string | null;
  asitePlaceholders?: AsitePlaceholderDto[] | null;
}

export interface PlaceholderFilterDto {
  documentIds?: number[] | null;
  linkSharedFolder?: boolean;
}

export interface PlaceholderPayloadDto {
  relaticsDocumentId?: string | null;
  organisation?: string | null;
  documentTitle?: string | null;
  deelproject?: string | null;
  phase?: string | null;
  object?: string | null;
  documentType?: string | null;
  disciplineCode?: string | null;
  relaticsSystem?: string | null;
  alternateReference?: string | null;
  workPackage?: string | null;
  linkSharedFolder?: boolean | null;
  purposeOfIssue?: string | null;
}

export interface PlaceholderResult {
  statusCode?: string | null;
  errorMessage?: string | null;
}

export interface PlaceholderSettingDto {
  /** @format uuid */
  id?: string | null;

  /** @format uuid */
  deelprojectId?: string | null;
  organisation?: string | null;
  workpackage?: string | null;
  documentType?: string | null;
  phase?: string | null;
  targetFolder?: string | null;

  /** @format int32 */
  targetFolderId?: number | null;
  targetWorkspaceName?: string | null;

  /** @format int32 */
  targetWorkspaceId?: number | null;
}

export interface PlaceholderSettingsFilterDto {
  deelproject?: string | null;
  organisation?: string | null;
  workpackage?: string | null;
  documentType?: string | null;
  phase?: string | null;
}

import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse, ResponseType } from "axios";

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams extends Omit<AxiosRequestConfig, "data" | "params" | "url" | "responseType"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType;
  /** request body */
  body?: unknown;
}

export type RequestParams = Omit<FullRequestParams, "body" | "method" | "query" | "path">;

export interface ApiConfig<SecurityDataType = unknown> extends Omit<AxiosRequestConfig, "data" | "cancelToken"> {
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
  secure?: boolean;
  format?: ResponseType;
}

export enum ContentType {
  Json = "application/json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance;
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private secure?: boolean;
  private format?: ResponseType;

  constructor({ securityWorker, secure, format, ...axiosConfig }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axios.create({ ...axiosConfig, baseURL: axiosConfig.baseURL || "" });
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  private mergeRequestParams(params1: AxiosRequestConfig, params2?: AxiosRequestConfig): AxiosRequestConfig {
    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...(this.instance.defaults.headers || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  private createFormData(input: Record<string, unknown>): FormData {
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      formData.append(
        key,
        property instanceof Blob
          ? property
          : typeof property === "object" && property !== null
          ? JSON.stringify(property)
          : `${property}`,
      );
      return formData;
    }, new FormData());
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<AxiosResponse<T>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = (format && this.format) || void 0;

    if (type === ContentType.FormData && body && body !== null && typeof body === "object") {
      requestParams.headers.common = { Accept: "*/*" };
      requestParams.headers.post = {};
      requestParams.headers.put = {};

      body = this.createFormData(body as Record<string, unknown>);
    }

    return this.instance.request({
      ...requestParams,
      headers: {
        ...(type && type !== ContentType.FormData ? { "Content-Type": type } : {}),
        ...(requestParams.headers || {}),
      },
      params: query,
      responseType: responseFormat,
      data: body,
      url: path,
    });
  };
}

/**
 * @title ProductReservation.ApiHost
 * @version 1.0
 */
export class Api<SecurityDataType extends unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  customAttributeMapping = {
    /**
     * No description
     *
     * @tags CustomAttributeMapping
     * @name CreateCreate
     * @request POST:/CustomAttributeMapping/create
     * @secure
     * @response `200` `CustomAttributeMappingDto` Success
     * @response `204` `void` No Content
     * @response `401` `void` Unauthorized
     * @response `404` `void` Not Found
     */
    createCreate: (data: CustomAttributeMappingDto, params: RequestParams = {}) =>
      this.http.request<CustomAttributeMappingDto, void>({
        path: `/CustomAttributeMapping/create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CustomAttributeMapping
     * @name UpdateUpdate
     * @request PUT:/CustomAttributeMapping/update
     * @secure
     * @response `200` `CustomAttributeMappingDto` Success
     * @response `204` `void` No Content
     * @response `401` `void` Unauthorized
     * @response `404` `void` Not Found
     */
    updateUpdate: (data: CustomAttributeMappingDto, params: RequestParams = {}) =>
      this.http.request<CustomAttributeMappingDto, void>({
        path: `/CustomAttributeMapping/update`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CustomAttributeMapping
     * @name DeleteDelete
     * @request DELETE:/CustomAttributeMapping/delete/{id}
     * @secure
     * @response `200` `CustomAttributeMappingDto` Success
     * @response `204` `void` No Content
     * @response `401` `void` Unauthorized
     * @response `404` `void` Not Found
     */
    deleteDelete: (id: string, params: RequestParams = {}) =>
      this.http.request<CustomAttributeMappingDto, void>({
        path: `/CustomAttributeMapping/delete/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CustomAttributeMapping
     * @name CustomAttributeMappingList
     * @request GET:/CustomAttributeMapping
     * @secure
     * @response `200` `(CustomAttributeMappingDto)[]` Success
     * @response `204` `void` No Content
     * @response `401` `void` Unauthorized
     * @response `404` `void` Not Found
     */
    customAttributeMappingList: (params: RequestParams = {}) =>
      this.http.request<CustomAttributeMappingDto[], void>({
        path: `/CustomAttributeMapping`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  deelproject = {
    /**
     * No description
     *
     * @tags Deelproject
     * @name CreateCreate
     * @request POST:/Deelproject/create
     * @secure
     * @response `201` `DeelprojectDto` Created
     * @response `400` `void` Bad Request
     * @response `401` `void` Unauthorized
     */
    createCreate: (data: DeelprojectDto, params: RequestParams = {}) =>
      this.http.request<DeelprojectDto, void>({
        path: `/Deelproject/create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Deelproject
     * @name UpdateUpdate
     * @request PUT:/Deelproject/update
     * @secure
     * @response `200` `DeelprojectDto` Success
     * @response `204` `void` No Content
     * @response `401` `void` Unauthorized
     * @response `404` `void` Not Found
     */
    updateUpdate: (data: DeelprojectDto, params: RequestParams = {}) =>
      this.http.request<DeelprojectDto, void>({
        path: `/Deelproject/update`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Deelproject
     * @name DeleteDelete
     * @request DELETE:/Deelproject/delete/{id}
     * @secure
     * @response `200` `DeelprojectDto` Success
     * @response `204` `void` No Content
     * @response `401` `void` Unauthorized
     * @response `404` `void` Not Found
     */
    deleteDelete: (id: string, params: RequestParams = {}) =>
      this.http.request<DeelprojectDto, void>({
        path: `/Deelproject/delete/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Deelproject
     * @name DeelprojectList
     * @summary Get all Deelprojects
     * @request GET:/Deelproject
     * @secure
     * @response `200` `(DeelprojectDto)[]` Success
     * @response `204` `void` No Content
     * @response `401` `void` Unauthorized
     */
    deelprojectList: (params: RequestParams = {}) =>
      this.http.request<DeelprojectDto[], void>({
        path: `/Deelproject`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  documentLinkHistory = {
    /**
     * No description
     *
     * @tags DocumentLinkHistory
     * @name CreateCreate
     * @request POST:/DocumentLinkHistory/create
     * @secure
     * @response `200` `(DocumentLinkHistoryDto)[]` Success
     * @response `204` `void` No Content
     * @response `401` `void` Unauthorized
     * @response `404` `void` Not Found
     */
    createCreate: (data: DocumentLinkHistoryDto[], params: RequestParams = {}) =>
      this.http.request<DocumentLinkHistoryDto[], void>({
        path: `/DocumentLinkHistory/create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags DocumentLinkHistory
     * @name FilterCreate
     * @request POST:/DocumentLinkHistory/filter
     * @secure
     * @response `200` `(DocumentLinkHistoryDto)[]` Success
     * @response `204` `void` No Content
     * @response `401` `void` Unauthorized
     * @response `404` `void` Not Found
     */
    filterCreate: (data: DocumentLinkHistoryFilterDto, params: RequestParams = {}) =>
      this.http.request<DocumentLinkHistoryDto[], void>({
        path: `/DocumentLinkHistory/filter`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  documentLinkSetting = {
    /**
     * No description
     *
     * @tags DocumentLinkSetting
     * @name CreateCreate
     * @request POST:/DocumentLinkSetting/create
     * @secure
     * @response `200` `DocumentLinkSettingDto` Success
     * @response `204` `void` No Content
     * @response `401` `void` Unauthorized
     * @response `404` `void` Not Found
     */
    createCreate: (data: DocumentLinkSettingDto, params: RequestParams = {}) =>
      this.http.request<DocumentLinkSettingDto, void>({
        path: `/DocumentLinkSetting/create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags DocumentLinkSetting
     * @name UpdateUpdate
     * @request PUT:/DocumentLinkSetting/update
     * @secure
     * @response `200` `DocumentLinkSettingDto` Success
     * @response `204` `void` No Content
     * @response `401` `void` Unauthorized
     * @response `404` `void` Not Found
     */
    updateUpdate: (data: DocumentLinkSettingDto, params: RequestParams = {}) =>
      this.http.request<DocumentLinkSettingDto, void>({
        path: `/DocumentLinkSetting/update`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags DocumentLinkSetting
     * @name DeleteDelete
     * @request DELETE:/DocumentLinkSetting/delete/{id}
     * @secure
     * @response `200` `DocumentLinkSettingDto` Success
     * @response `204` `void` No Content
     * @response `401` `void` Unauthorized
     * @response `404` `void` Not Found
     */
    deleteDelete: (id: string, params: RequestParams = {}) =>
      this.http.request<DocumentLinkSettingDto, void>({
        path: `/DocumentLinkSetting/delete/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags DocumentLinkSetting
     * @name DocumentLinkSettingList
     * @request GET:/DocumentLinkSetting
     * @secure
     * @response `200` `(DocumentLinkSettingDto)[]` Success
     * @response `204` `void` No Content
     * @response `401` `void` Unauthorized
     * @response `404` `void` Not Found
     */
    documentLinkSettingList: (params: RequestParams = {}) =>
      this.http.request<DocumentLinkSettingDto[], void>({
        path: `/DocumentLinkSetting`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags DocumentLinkSetting
     * @name DocumentLinkSettingDetail
     * @request GET:/DocumentLinkSetting/{id}
     * @secure
     * @response `200` `DocumentLinkSettingDto` Success
     * @response `204` `void` No Content
     * @response `401` `void` Unauthorized
     * @response `404` `void` Not Found
     */
    documentLinkSettingDetail: (id: string, params: RequestParams = {}) =>
      this.http.request<DocumentLinkSettingDto, void>({
        path: `/DocumentLinkSetting/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  placeholder = {
    /**
     * No description
     *
     * @tags Placeholder
     * @name RestLinearDataCreate
     * @request POST:/Placeholder/rest-linear-data
     * @secure
     * @response `200` `PlaceholderResult` Success
     * @response `204` `void` No Content
     * @response `401` `void` Unauthorized
     * @response `404` `void` Not Found
     */
    restLinearDataCreate: (data: PlaceholderPayloadDto, params: RequestParams = {}) =>
      this.http.request<PlaceholderResult, void>({
        path: `/Placeholder/rest-linear-data`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Placeholder
     * @name FilterCreate
     * @request POST:/Placeholder/filter
     * @secure
     * @response `200` `PlaceholderDto` Success
     * @response `204` `void` No Content
     * @response `401` `void` Unauthorized
     * @response `404` `void` Not Found
     */
    filterCreate: (data: PlaceholderFilterDto, params: RequestParams = {}) =>
      this.http.request<PlaceholderDto, void>({
        path: `/Placeholder/filter`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  placeholderSetting = {
    /**
     * No description
     *
     * @tags PlaceholderSetting
     * @name CreateCreate
     * @request POST:/PlaceholderSetting/create
     * @secure
     * @response `200` `PlaceholderSettingDto` Success
     * @response `204` `void` No Content
     * @response `401` `void` Unauthorized
     * @response `404` `void` Not Found
     */
    createCreate: (data: PlaceholderSettingDto, params: RequestParams = {}) =>
      this.http.request<PlaceholderSettingDto, void>({
        path: `/PlaceholderSetting/create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PlaceholderSetting
     * @name UpdateUpdate
     * @request PUT:/PlaceholderSetting/update
     * @secure
     * @response `200` `PlaceholderSettingDto` Success
     * @response `204` `void` No Content
     * @response `401` `void` Unauthorized
     * @response `404` `void` Not Found
     */
    updateUpdate: (data: PlaceholderSettingDto, params: RequestParams = {}) =>
      this.http.request<PlaceholderSettingDto, void>({
        path: `/PlaceholderSetting/update`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PlaceholderSetting
     * @name DeleteDelete
     * @request DELETE:/PlaceholderSetting/delete/{id}
     * @secure
     * @response `200` `PlaceholderSettingDto` Success
     * @response `204` `void` No Content
     * @response `401` `void` Unauthorized
     * @response `404` `void` Not Found
     */
    deleteDelete: (id: string, params: RequestParams = {}) =>
      this.http.request<PlaceholderSettingDto, void>({
        path: `/PlaceholderSetting/delete/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PlaceholderSetting
     * @name PlaceholderSettingList
     * @request GET:/PlaceholderSetting
     * @secure
     * @response `200` `(PlaceholderSettingDto)[]` Success
     * @response `204` `void` No Content
     * @response `401` `void` Unauthorized
     * @response `404` `void` Not Found
     */
    placeholderSettingList: (params: RequestParams = {}) =>
      this.http.request<PlaceholderSettingDto[], void>({
        path: `/PlaceholderSetting`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PlaceholderSetting
     * @name FilterCreate
     * @request POST:/PlaceholderSetting/filter
     * @secure
     * @response `200` `PlaceholderSettingDto` Success
     * @response `204` `void` No Content
     * @response `401` `void` Unauthorized
     * @response `404` `void` Not Found
     */
    filterCreate: (data: PlaceholderSettingsFilterDto, params: RequestParams = {}) =>
      this.http.request<PlaceholderSettingDto, void>({
        path: `/PlaceholderSetting/filter`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
}
